













import { Component, Vue, Prop } from 'vue-property-decorator'
import JoinParty from '@/components/home/JoinParty.vue'
import CreateParty from '@/components/home/CreateParty.vue'
@Component({
  components: { CreateParty, JoinParty }
})
export default class MobileBody extends Vue {
  code = ''
  mode = 'join'

  changeMode (mode: string) {
    this.mode = mode
  }
}
